<template>
  <div class="slot-list">
    <timetable-patient-cell
      v-bind:appointment-id="slot.id"
      v-bind:interval="slot.interval"
      v-bind:is-initial="slot.patient.is_initial"
      v-bind:key="slot.id"
      v-bind:patient-name="slot.patient.name"
      v-bind:ratio-step="slot.ratio_to_step"
      v-bind:style="{ 'background-color': slot.color }"
      v-bind:tags="slot.tags"
      v-for="slot in list"
      v-on:click="dispatchSelect(slot)" />
  </div>
</template>
<script>
import { builtInPopoverMixin } from '@/mixins/builtInPopoverMixin';
import TimetablePatientCell from './TimetablePatientCell.vue';

/**
 * @description Компонент формы выбора рабочего режима сотрудника.
 * @type {Vue}
 */
export default {
  components: { TimetablePatientCell },
  methods: {
    dispatchSelect(slot) {
      this.$emit('select', slot);
      this.closePopover();
    },
  },
  mixins: [builtInPopoverMixin],
  name: 'FormSelectTimetableCell',
  props: {
    list: { type: Array, required: true },
  },
};
</script>
<style scoped>
.slot-list {
  overflow: visible;
}
</style>
